/*==========================================================
SCROLL FUNCTION SCRIPT
==========================================================*/
var disableVerticalScroll = true; //disables the functionality to scroll to #pageHeading by passing interior banner
var headerHeight = $("header").height();
var $viewport = $('html, body');

$(function() {

    $(window).scroll(function() {
        disableVerticalScroll = true;
    });

    $viewport.on("scroll mousedown DOMMouseScroll mousewheel keyup", function(e){
        if ( e.which > 0 || e.type === "mousedown" || e.type === "mousewheel"){
             $viewport.stop().unbind('scroll mousedown DOMMouseScroll mousewheel keyup'); // This identifies the scroll as a user action, stops the animation, then unbinds the event straight after (optional)
        }
    });

    // Scroll to Anchor links when link to anchor is clicked on the same page
    $('#printAreaContent a[href*=#]:not([href=#]), #printAreaContentDotNet a[href*=#]:not([href=#]), #skipContentLink').click(function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + decodeURI(this.hash.slice(1)).replace(/\s|[`~!@#$%^&*()|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '') + ']');
            if (target.parents('.AccordionContent').length || target.parents('.AccordionTrigger').length) { //if clicking accordion link or link in accordion

                if (target.parents('.AccordionTrigger').length) {
                    target.closest('.AccordionTrigger').addClass('open');
                    target.closest('.AccordionTrigger').next().slideDown("100");
                } else if (target.parents('.AccordionContent').length) {
                    $('.AccordionContent:visible').slideUp("100");
                    $('.AccordionTrigger').removeClass('open');
                    target.parents('.AccordionContent').slideDown("100");
                    target.parents('.AccordionContent').prev().addClass('open');
                }
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - headerHeight //Offset scroll position of anchor link for sticky header
                    }, 1000);
                    target.focus();
                    return false;
                }
            } else if (target.length) {
                $viewport.stop().animate({
                    scrollTop: target.offset().top - headerHeight //Offset scroll position of anchor link for sticky header
                }, 1000);
                target.focus();
                return false;
            }
        }
    });

    // Set Tab focus to appear below sticky header
    $("#uber").on("keyup", "select, input, textarea, button, a, div[tabindex='0']", function(e){
        var code = (e.keyCode ? e.keyCode : e.which);
        if (code == 9 && $("select:focus, input:focus, textarea:focus, button:focus, a:focus, div[tabindex='0']:focus").length) {
            if (e.target.id == "skipContentLink") {  //scroll up to skipContentLink
                $viewport.stop().animate({
                    scrollTop: 0
                }, 500);
            } else if (!$(e.currentTarget).closest("header").length) {
                var ele = $(e.currentTarget).offset().top;
                var eleTop = ele - $(window).scrollTop();
                var newPos = ele - headerHeight;

                if (headerHeight > eleTop) {
                    $viewport.stop().animate({
                        scrollTop: newPos
                    }, 500);
                }
            }
        }
    });
});
